import { IonicPageModule } from 'ionic-angular';
import { NgModule } from '@angular/core';
import { SellionsFormsModule } from '../../../../submodules/sellions_forms/projects/forms/src/public-api';
import { UserTaskPreviewPage } from './user-task-preview';
import {UserTaskInfoPage} from "./info/user-task-info";

@NgModule({
  declarations: [UserTaskPreviewPage],
  entryComponents: [UserTaskInfoPage],
  imports: [IonicPageModule.forChild(UserTaskPreviewPage), SellionsFormsModule],
})
export class UserTaskPreviewModule {}



// WEBPACK FOOTER //
// ./src/modules/user-tasks/pages/user-task-preview/user-task-preview.module.ts